import React from "react";

export const VSpace = ({ height = 10 }: { height?: number }) => {
  return <div style={{ height }} />;
};
